/**
* Location based popup
*/
class locationPopup extends HTMLElement {
    constructor() {
        super();
        this.checkForInitial = false;
        if(document.referrer == 'https://shopify.com/'){
        // Utility.removeCookie('locationID')
        }

        if(Utility.getCookie('customer_location') != document.querySelector('[data-currentSelectedAddress]').getAttribute('data-currentSelectedAddress').toLowerCase()){
            Utility.removeCookie('locationID');
            Utility.removeCookie('cif_customerLocationData');
            Utility.removeFromLocalStorage('QuickListProducts');
            Utility.removeCookie('warehouseID');
        }

        // Instead of below JSOn we will use API
        //let locationJSONEle = document.querySelector('[data-locationScriptJSON]');
        this.locationPopup =  this.querySelector('.pdp-modal-content');
        this.closeLocationPopupbtn = this.querySelector('[data-close-location]')

        this.loadLocation();
        if(Utility.getCookie('locationID') == ''){
            this.checkForInitial = true;
        }else{
           
        }

        if(document.querySelector('[datalocation-select]')){
            document.querySelector('[datalocation-select]').addEventListener('change', this.selectChange.bind(this));
        }

      
    }

    getPreviousPageUrl() {
        history.back();
        return location.href;
    }

    loadLocation(){
        fetch('https://shopifyapi2.jinny.com/api/get-locations',{
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        }).
        then(response => {
            return response.json();
          }).then(response => {
            let locationJSON = (response);

            /* START:: Added restriction for not match URL or site with selected Location */
            if(Utility.getCookie('locationID') != ''){
                locationJSON.locations.forEach(function(data, index) {
                    if(parseInt(data.location_id) == parseInt(Utility.getCookie('locationID'))){
                        let dataurl = `https://${window.globalVariables.domain}${data.redirect_link}` 
                       
                    }
                });
            }

            this.fillPopup(locationJSON)
          }).catch((e) => {
              console.error(e);
              window.Rollbar?.error(`File: component-location-popup.js, getting error on loadLocation: ${e}`);
          }).finally(() => {
              // Cart HTML fetch done
          });

        
    }

    fetchLocation(){
        fetch("https://jinny-beauty-backend.localhost/api/get-locations", {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            body: JSON.stringify(requestData),
            }).then((data) =>{
                // console.log('data',data);
            });
    }

    openPopup(){
        document.getElementById('LocationPopup').querySelector('.modal').classList.add('open');
        document.querySelector('body').classList.add('open-location')
        siteOverlay.prototype.showOverlay();
    }
  
    /**
     * Shown when the signed-in customer has no usable warehouse.
     *
     * hasCompanyLocation = false: the account has no B2B company location at all. This is
     * what an account created through "Sign in with Shop" looks like - the backend flow
     * that deletes accounts without the wholesale_approved tag does not catch it, so the
     * customer lands here signed in with nothing to select.
     *
     * Previously both cases rendered a hard-coded shopify.com/<id>/account/locations link whose
     * id was jinny.com's shop id (copied from the Jinny theme), so the only
     * button in the popup sent BUD customers to Jinny's customer account / jinny.com, and the
     * close button was hidden, leaving no way out. The URLs now come from Liquid
     * (shop.id / routes.account_logout_url on <location-popup>), and the popup can be
     * dismissed or the customer can log out.
     */
    showNoWarehouse(hasCompanyLocation) {
        const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        const logoutUrl = this.dataset.logoutUrl || (root + 'account/logout');
        const locationsUrl = this.dataset.locationsUrl || '';

        let html;
        if (hasCompanyLocation) {
            html = `<div class="text-center">There are no warehouse available at your shipping location.<br><br>`
                + (locationsUrl ? `<a href="${locationsUrl}">Please select a different shipping location</a><br><br>` : '')
                + `<a href="${logoutUrl}" class="btn btn-primary">Log out</a></div>`;
        } else {
            html = `<div class="text-center">This account is not set up for wholesale ordering.<br><br>`
                + `Barber United Supply sells to approved wholesale customers only. If you already have a wholesale account, please log out and sign in with the email address registered to it.<br><br>`
                + `<a href="${logoutUrl}" class="btn btn-primary">Log out</a></div>`;
        }

        this.locationPopup.style = "margin-top:30px;";
        this.locationPopup.innerHTML = html;
        this.openPopup();
        // Keep the close (X) button visible so the popup is never a dead end.
        if (this.closeLocationPopupbtn) this.closeLocationPopupbtn.classList.remove('d-none');
    }

    /**
     * Escape Key Press to close drawer when focus is within the container
     *
     * @param {event} Event instance
     */
    fillPopup(jsonData) {
        
        let getCustomerTag = document.querySelector('[data-cust-tags]').getAttribute('data-cust-tags');
        let getCurrentSelectedLocation = document.querySelector('[data-currentSelectedAddress]').getAttribute('data-currentSelectedAddress').toLowerCase();

        if(getCurrentSelectedLocation != ''){

        let getCustomerTags = getCustomerTag.split(',');
        let cureentLocations = document.querySelector('[data-currentSelectedAddress]').getAttribute('data-currentlocations').split(',');

        let arrayLocation = [];
        getCustomerTags.forEach(function(data1, index1) {
            if(data1 != ''){
            let location = data1.replace('location_','');
            cureentLocations.forEach(data2 => {
                    if(parseInt(location) == parseInt(data2)){
                            arrayLocation.push(parseInt(data2));
                    }
                });
            }
        });
        var finalLocationArray = arrayLocation.filter((value, index, array) => array.indexOf(value) === index);
        jsonData.locations.forEach(function(data, index) {
            finalLocationArray.forEach(function(data1, index1) {
                if(data1 != ''){
                    
                    if(Number(data.warehouse_id) == Number(data1)){
                        
                        var optionEle = document.createElement("option");
                        optionEle.text = data.name;
                        // BUD's warehouse has no redirect_link. Assigning null here gives the
                        // option the literal string "null", which selectChange then navigated to.
                        optionEle.value = data.redirect_link ?? '';
                        // console.log('data.location_id',data.location_id);
                        optionEle.setAttribute('data-location-id',Number(data.location_id));
                        optionEle.setAttribute('data-warehouse-id',Number(data.warehouse_id));
                        optionEle.setAttribute('class','product-custom-option');
                        var select = document.querySelector("[datalocation-select]");
                        select.appendChild(optionEle);
                        Utility.setCookie('locationID', Number(data.location_id), 7);
                        Utility.setCookie('warehouseID', Number(data.warehouse_id), 7);
                        /*
                          The constructor clears locationID / warehouseID / cif_customerLocationData
                          and QuickListProducts whenever customer_location disagrees with the account's
                          current B2B location. customer_location used to be written only inside
                          `if (getCookie('locationID') != data.location_id)` - compared against the value
                          set two lines above, so never true. selectChange writes it too, but that needs
                          a dropdown change, which a customer with a single location can never make. So
                          on this store it was never written and the clear ran on every page load: the
                          quick-order list was lost on every navigation and locationID read blank until
                          this callback restored it a few hundred ms later.

                          Written here unconditionally, the clear now fires only on a real location change.
                        */
                        Utility.setCookie('customer_location', getCurrentSelectedLocation, 7);
                        Utility.setCookie('popupLocation', data.name, 7);

                    }
                }
            });
            if(parseInt(Utility.getCookie('locationID')) === parseInt(data.location_id)){
                if(document.querySelector('[data-location-id="' + data.location_id + '"]')){
                    document.querySelector('[data-location-id="' + data.location_id + '"]').selected = true;
                }
                var getSelect = document.querySelector("[datalocation-select]");
                var text = getSelect.options[getSelect.selectedIndex].text;
                document.querySelector('[data-location-name]').innerHTML = text;
                document.querySelector('[data-location-dropdown]').classList.remove('d-none');
            }
        });
        
        var selectOptions = document.querySelectorAll("[datalocation-select] option")
        if(selectOptions.length == 1){
            
            this.showNoWarehouse(true);
        }
        }else{
            this.showNoWarehouse(false);
        }
    }

    selectChange(event){

        let selectedOption = event.currentTarget.options[event.currentTarget.selectedIndex].value;
        let getLocation = event.currentTarget.options[event.currentTarget.selectedIndex].getAttribute('data-location-id');
        let getwarehouseId = event.currentTarget.options[event.currentTarget.selectedIndex].getAttribute('data-warehouse-id');

        Utility.removeFromLocalStorage('QuickListProducts');
        Utility.removeCookie('cif_customerLocationData');
        Utility.setCookie('locationID', getLocation, 7);
        Utility.setCookie('warehouseID', getwarehouseId, 7);
        Utility.setCookie('customer_location',document.querySelector('[data-currentSelectedAddress]').getAttribute('data-currentSelectedAddress').toLowerCase());
        Utility.setCookie('popupLocation', event.currentTarget.options[event.currentTarget.selectedIndex].text, 7);

        /*
          currentLocation deliberately survives. component-cart-form.js swaps the cart only
          while that cookie still holds the PREVIOUS location - removing it here made the next
          load look like the first visit of a session, so the old location's cart stayed put
          and was relabelled as the new location's.

          The cart is not emptied here either. That swap (cartAPIs) reads the new location's
          saved cart before it clears anything and refills from it; a bare /cart/clear.js is
          never reported to the backend, so it dropped the cart on the floor.
        */
        var redirectLink = selectedOption && selectedOption !== 'null' ? selectedOption : '';
        if (redirectLink) {
            window.location.href = redirectLink;
        } else {
            // Same storefront (BUD has one warehouse and no redirect_link): reload in place.
            window.location.reload();
        }
    }
  
}
customElements.define("location-popup", locationPopup);
